import { lazy } from 'react';

const Tools = lazy(() => import('./Tools'));

export default Tools;
